// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3MZ_O","count":"Tabs_count__3uUq0","isActive":"Tabs_isActive__3ClFE","scroll":"Tabs_scroll__2dUHd"};